import React, { useEffect, useRef, useState } from 'react'
import { PageHeader, Form, Row, Col, Descriptions } from 'antd'
import { useParams, useNavigate } from 'react-router-dom';
import { UserAddOutlined, LeftCircleOutlined  } from '@ant-design/icons';
import { useApiContext } from "../../hooks/useApiContext";
import moment from "moment";
import apis from "../../services/apis";

export default function EmployeeDetails() {
    const { employeedispatch, projectdispatch, projects, clientdispatch, clients} = useApiContext()
    const [employeeData, setEmployeeData] = useState()
    const {id} = useParams()
    const navigate = useNavigate()
    useEffect(()=>{
        if(id){
            apis.Employees.get(id).then(res =>{
                setEmployeeData(res.data)
            })
        }
    },[id])
     
    if(!employeeData) return <div>Loading...</div>
    console.log("employee data", employeeData);
  return (
      <>
       <PageHeader
    className="site-page-header"
    onBack={() => navigate(-1)}
    title="Employee details"
    subTitle="Find all the employee details here"
  />
    <Descriptions labelStyle={{fontWeight:'bold'}} bordered>
        <Descriptions.Item label="Employee ID" span={2}>{employeeData.empId}</Descriptions.Item>
        <Descriptions.Item label="Employee Name">{employeeData.fullName}</Descriptions.Item>
        <Descriptions.Item label="Gender" span={2}>{employeeData.gender}</Descriptions.Item>
        <Descriptions.Item label="Nationality">{employeeData.nationality}</Descriptions.Item>
        <Descriptions.Item label="Date of birth" span={2}>{employeeData.dob}</Descriptions.Item>
        <Descriptions.Item label="Passport Number">{employeeData.passportNumber}</Descriptions.Item>
        <Descriptions.Item label="Project Name" span={2}>{employeeData.project.projectName}</Descriptions.Item>
        <Descriptions.Item label="MOL ID" >{employeeData.molId}</Descriptions.Item>
        <Descriptions.Item label="Basic salary" span={2}>{employeeData.basicSalary}</Descriptions.Item>
        <Descriptions.Item label="Experience">{employeeData.experience}</Descriptions.Item>
        <Descriptions.Item label="Work Shift" span={2}>{employeeData.workShift}</Descriptions.Item>
        <Descriptions.Item label="Leave policy" span={2}>{employeeData.leavePolicy}</Descriptions.Item>
        <Descriptions.Item label="Border Number" span={2}>{employeeData.borderNumber}</Descriptions.Item>
        <Descriptions.Item label="KSA Entry date">{employeeData.entryDate}</Descriptions.Item>
        <Descriptions.Item label="Iqama Number" span={2}>{employeeData.iqamaNumber}</Descriptions.Item>
        <Descriptions.Item label="Iqama Expiry date">{employeeData.expiryDate}</Descriptions.Item>
        <Descriptions.Item label="References" span={2}>{employeeData.reference}</Descriptions.Item>
        <Descriptions.Item label="Remarks">{employeeData.remarks}</Descriptions.Item>
    </Descriptions>
      </>
  )
}
